import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors } from '@lean-body/components/styles';
import { Overlay } from '../organisms/overlay';
import { LoadingIcon } from '../atoms/loading_icon';
export const DailyLessonChangeLoadingView = () => (React.createElement(Overlay, { background: "rgba(0, 0, 0, 0.4)" },
    React.createElement("div", { className: css(styles.content) },
        React.createElement(LoadingIcon, { classObject: styles.icon }),
        React.createElement("div", { className: css(styles.text) },
            React.createElement("div", null, "\u3042\u306A\u305F\u306B\u5408\u3046"),
            React.createElement("div", null, "\u30EC\u30C3\u30B9\u30F3\u3092\u9078\u3093\u3067\u3044\u307E\u3059\u2026")))));
const styles = StyleSheet.create({
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 12,
    },
    icon: {
        width: 43,
        height: 41,
    },
    text: {
        color: Colors.White,
        textAlign: 'center',
        fontSize: 12,
        fontWeight: 500,
        lineHeight: '160%',
        letterSpacing: '0.48px',
    },
});
